<template>
  <div class="p-3 border rounded-3">
    <b-row class="justify-content-end">
      <b-col lg="4" class="text-right">
        <b-form-input
          ref="searchInput"
          v-model="search"
          :placeholder="$t('global.search') + '...'"
        />
      </b-col>
    </b-row>
    <div class="table-responsive my-3 border border-1">
      <b-table
        small
        show-empty
        :empty-text="$t('global.emptyTable')"
        :empty-filtered-text="$t('global.emptyFilteredTable')"
        :fields="fields"
        :items="items"
        :per-page="limit"
        :current-page="page"
        responsive="sm"
        class="datatables"
        :filter="search"
      >
        <slot />
        <!-- Default slots for job history table -->
        <template #cell(columnCompany)="data">
          <span>{{ data.item.companyName }}</span>
        </template>
        <template #cell(columnPosition)="data">
          <span>{{ data.item.position }}</span>
        </template>
        <template #cell(columnEntryDate)="data">
          <span>{{ momentDateShortMonth(data.item.joinedOn) }}</span>
        </template>
        <template #cell(columnExitDate)="data">
          <span>{{ momentDateShortMonth(data.item.leftOn) }}</span>
        </template>
        <!-- Default slots for identity table -->
        <template #cell(columnDocument)="data">
          <span>{{ data.item.docType }}</span>
        </template>
        <template #cell(columnNomor)="data">
          <span>{{ data.item.docNumber }}</span>
        </template>
        <template #cell(columnExpired)="data">
          <span>{{ data.item.validUntil ? momentDateShortMonth(data.item.validUntil) : '' }}</span>
        </template>
        <template #cell(columnStatus)="data">
          <div>
            <span
              v-if="getIdentityStatus(data.item.validUntil) == 'Kedaluwarsa'"
              class="mc-status mc-status--red"
            >
              {{ $t('master.form.employee.expired') }}
            </span>
            <span
              v-else-if="getIdentityStatus(data.item.validUntil) == 'Akan Kedaluwarsa'"
              class="mc-status mc-status--yellow"
            >
              {{ $t('master.form.employee.willExpired') }}
            </span>
            <span
              v-else-if="getIdentityStatus(data.item.validUntil) == 'Berlaku'"
              class="mc-status mc-status--green"
            >
              {{ $t('master.form.employee.valid') }}
            </span>
          </div>
        </template>
      </b-table>
    </div>
    <div class="d-flex flex-wrap flex-md-nowrap w-100">
      <div class="mc-limit">
        <div class="__limit">
          {{ $t('global.text.displays') }}
          <b-form-select
            v-model="limit"
            class="form-select form-select-sm __limit--dropdown"
            size="sm"
            :options="limitOptions"
          />
          <div>{{ $t('global.text.data') }}</div>
        </div>
        <div class="__info">
          <strong>{{ startData }}</strong> - <strong>{{ endData }}</strong>
          {{ $t('global.object.of') }} <strong>{{ totalCount }}</strong>
          {{ $t('global.text.data') }}
        </div>
      </div>
      <div class="mc-pagination-container">
        <b-pagination v-model="page" :total-rows="totalCount" :per-page="limit" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'LoadsTable',
  props: {
    items: { type: Array, required: true },
    fields: { type: Array, required: true },
    limitOptions: { type: Array, default: () => [5, 10, 25, 50, 100] },
  },
  data() {
    return {
      page: 1,
      search: '',
      limit: 5,
    }
  },
  computed: {
    totalCount() {
      return this.items.length
    },
    startData() {
      return this.limit * this.page - this.limit + 1
    },
    endData() {
      const _endData = this.limit * this.page
      return this.totalCount < _endData ? this.totalCount : _endData
    },
  },
  methods: {
    momentDateShortMonth(date) {
      return date ? moment(date).format('DD MMM YYYY') : '-'
    },
    getIdentityStatus(data) {
      if (data == '' || data == null) return null
      let now = moment(new Date())
      let date = moment(data)
      let diff = now.diff(date, 'days') * -1

      if (diff >= 30) {
        return 'Berlaku'
      } else if (diff < 30 && diff >= 0) {
        return 'Akan Kedaluwarsa'
      } else if (diff <= 0) {
        return 'Kedaluwarsa'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
